import { normalizePortfolioAddress } from "./db/models";

export function dedupeNonEmpty(
  values: readonly (string | null | undefined)[],
  normalize: (value: string) => string = (value) => value.trim(),
): string[] {
  const seen = new Set<string>();
  const output: string[] = [];

  for (const value of values) {
    if (!value) {
      continue;
    }

    const normalized = normalize(value);
    if (normalized.length === 0 || seen.has(normalized)) {
      continue;
    }

    seen.add(normalized);
    output.push(normalized);
  }

  return output;
}

export function normalizeAddressList(
  addresses: readonly (string | null | undefined)[],
): string[] {
  return dedupeNonEmpty(addresses, normalizePortfolioAddress);
}
